import React from "react";
import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
import AppRoutes from "./routes";
import store from "./store.js";
import { DruvaAlertsProvider, DruvaAlertsContext, useDruvaAlerts } from "./contexts/DruvaAlertsContext";
/**
 * The props: 
 * {
  "apiConfig": {
    "alertsPath": "",
    "accessToken": "",
    "listadminsApiPath": "",
    "alertsApiPath": "https://console.druva.com/realize/eventmanagement/v1"
  }
}
 */

var DruvaAlerts = function DruvaAlerts(props) {
  var routes = useRoutes([{
    path: "/*",
    element: /*#__PURE__*/React.createElement(AppRoutes, null)
  }]);
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, routes);
};

export { DruvaAlertsProvider, DruvaAlertsContext, useDruvaAlerts };
export default DruvaAlerts;